import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[640px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=grand%20soccer%20stadium%20filled%20with%20passionate%20fans%20under%20dramatic%20golden%20sunset%20sky%2C%20confetti%20and%20flags%20waving%2C%20World%20Cup%20atmosphere%2C%20wide%20angle%20view%20from%20upper%20stands%2C%20warm%20golden%20and%20amber%20tones%2C%20epic%20cinematic%20lighting%2C%20professional%20sports%20photography%2C%20emotional%20and%20powerful%20scene&width=1920&height=1080&seq=hero-bg-main&orientation=landscape)`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4">
            世界杯门票去哪买？
          </h1>
          <p className="text-base md:text-lg text-background-50/90 leading-relaxed mb-8 max-w-2xl mx-auto">
            官方正规购票渠道全攻略 &mdash; 汇总FIFA官网、授权代理商、球迷套餐等全渠道信息，帮你安全买到心仪世界杯门票，拒绝假票风险
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/fifa-official"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-shield-check-line"></i>
              查看官方购票渠道
            </Link>
            <Link
              to="/category/ticket-tips"
              className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-sm hover:bg-background-50/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-flashlight-line"></i>
              抢票攻略与技巧
            </Link>
          </div>

          <div className="mt-10 flex items-center justify-center gap-6 md:gap-10 text-background-50/70 text-sm">
            <div className="flex items-center gap-2">
              <i className="ri-article-line"></i>
              <span>30+ 篇指南</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-store-2-line"></i>
              <span>5 大渠道</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-line"></i>
              <span>100% 官方</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}